import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import DataConfig from '../../data';
import storage from '../Grid/util/storage';
import Utils from '../../utils';
import AppsUtils from '../../apps/utils';
var defaults = {
  idKeyProp: 'Id',
  page: 0,
  itemsPerPage: 10,
  sort: 'asc',
  by: 'Name',
  filter: ''
};
/**
 *
 * @param {string} viewId  The view identifier
 * @param {import('data/types').CollectionViewState} viewState  The redux view state
 * @param {import('data/types').CollectionViewState} props  Override the redux view state
 * @returns {import('data/types').CollectionViewState}  The final merged view state
 */

export var getNextView = function getNextView(viewId, viewState, props) {
  /**@type any */
  var nextView = {};
  if (!viewState) nextView = {
    id: viewId
  };else nextView = _objectSpread({}, viewState);
  var itemDefaults = defaults;
  var dataType = nextView.dataType || props.dataType;

  if (dataType && DataConfig[dataType] && DataConfig[dataType].data) {
    itemDefaults = _objectSpread({}, defaults, DataConfig[dataType].data);
  }

  nextView = _objectSpread({}, itemDefaults, nextView);
  var savedData = storage.get(viewId);

  if (savedData) {
    nextView = _objectSpread({}, nextView, savedData);
  }

  if (props) {
    nextView = _objectSpread({}, nextView, props);
  }

  if (!nextView.dataKey) nextView.dataKey = 'v_' + nextView.id;
  return nextView;
};
export var persistViewState = function persistViewState(viewState) {
  return storage.save(viewState.id, _objectSpread({}, viewState, {
    page: undefined //do not persist the current page

  }));
};
export var getRequestQuery = function getRequestQuery(_ref, props) {
  var id = _ref.id,
      url = _ref.url,
      page = _ref.page,
      itemsPerPage = _ref.itemsPerPage,
      by = _ref.by,
      sort = _ref.sort,
      filter = _ref.filter,
      filterUrlKey = _ref.filterUrlKey;
  var query = {
    StartIndex: page * itemsPerPage,
    RowLimit: itemsPerPage
  };
  if (by) query.SortField = by;
  if (sort) query.SortOrder = sort;

  if (filter) {
    var key = filterUrlKey || 'Filter';
    query[key] = filter;
  } //data grid filter to query


  if (props && props.dataProps && props.dataProps.filter) {
    var filterProps = props.dataProps.filter;
    if (filterProps.filterBy && filterProps.filterValue) query[filterProps.filterBy] = filterProps.filterValue;
    if (filterProps.searchIn && filterProps.searchValue) query[filterProps.searchIn] = filterProps.searchValue;
  } //data grid filter to query


  if (props && props.dataProps && props.dataProps.ids) query['ids'] = props.dataProps.ids.join(',');
  var request = {
    id: id,
    url: url,
    query: query
  };
  return request;
};
/**@return {import('data/types').DataActionRequest} */

export var runRequestHook = function runRequestHook(hook, props, requestAction, item, dataTypeConfig) {
  if (dataTypeConfig && dataTypeConfig.data && dataTypeConfig.data.app) {
    var app = dataTypeConfig.data.app;
    requestAction = _objectSpread({}, requestAction, {
      url: AppsUtils.invokeApp(app, requestAction.url)
    });
  }

  if (!hook) return requestAction;
  if (typeof hook === 'object') return Utils.deepMerge(requestAction, hook);
  if (typeof hook !== 'function') return requestAction;

  for (var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
    rest[_key - 5] = arguments[_key];
  }

  var changes = hook.apply(void 0, [props, requestAction, item, dataTypeConfig].concat(rest));
  if (!changes) return requestAction;

  if (typeof changes === 'string') {
    changes = {
      url: changes
    };
  }

  var request = Utils.deepMerge(requestAction, changes);
  return request;
};
/**@return {import('data/types').DataActionRequest} */

export var runResponseHook = function runResponseHook(hook, props, requestAction, responseBody, item, dataTypeConfig) {
  if (!hook) return responseBody;
  if (typeof hook === 'object') return Utils.deepMerge(responseBody, hook);
  if (typeof hook !== 'function') return responseBody;

  for (var _len2 = arguments.length, rest = new Array(_len2 > 6 ? _len2 - 6 : 0), _key2 = 6; _key2 < _len2; _key2++) {
    rest[_key2 - 6] = arguments[_key2];
  }

  var changedBody = hook.apply(void 0, [props, requestAction, responseBody, item, dataTypeConfig].concat(rest));
  if (!changedBody) return responseBody;
  var newResponseBody = Utils.deepMerge(responseBody, changedBody);
  return newResponseBody;
};
export default {
  getNextView: getNextView,
  getRequestQuery: getRequestQuery,
  runRequestHook: runRequestHook,
  runResponseHook: runResponseHook
};